var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('dash-board-top-card-item'),_c('dash-board-top-card-item'),_c('dash-board-top-card-item'),_c('dash-board-top-card-item')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }